import { useCheckActions } from "../actions/checkActions"
import { usePaymentOrderActions } from "../actions/paymentOrderActions"
import { useCheckBuilders } from "../builders/checkBuilders"
import { usePaymentOrderBuilders } from "../builders/paymentOrderBuilders"
import { useCheckLoaders } from "../loaders/checkLoaders"
import { usePaymentOrderLoaders } from "../loaders/paymentOrderLoaders"

export const useCheckService = () => {
    const { buildCheck } = useCheckBuilders()

    const checkLoaders = useCheckLoaders()

    const { saveCheck } = useCheckActions()

    const archiveCheck = async (checkId: string) => {
        const { loadCheck } = checkLoaders()
        const check = await loadCheck(checkId, true)
        const archivedCheck = buildCheck({
            ...check,
            archived: true
        })
        return saveCheck(archivedCheck)
    }

    return {
        archiveCheck
    }
}

export const usePaymentOrderService = () => {
    const { buildPaymentOrder } = usePaymentOrderBuilders()

    const paymentOrderLoaders = usePaymentOrderLoaders()

    const paymentOrderActions = usePaymentOrderActions()

    const archivePaymentOrder = async (paymentOrderId: string) => {
        const { loadPaymentOrder } = paymentOrderLoaders()
        const paymentOrder = await loadPaymentOrder(paymentOrderId, true)
        const archivedPaymentOrder = buildPaymentOrder({
            ...paymentOrder,
            archived: true
        })
        const { savePaymentOrder } = paymentOrderActions()
        return savePaymentOrder(archivedPaymentOrder)
    }

    return {
        archivePaymentOrder
    }
}
